import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { IProjectAsset } from '../types';

const getProjectAssets = async (projectUuid: string): Promise<Array<IProjectAsset>> => {
    const response = await axiosInstance.get(API_ENDPOINTS.PROJECT_ASSETS(projectUuid));
    return response.data;
};

export const useGetProjectAssets = (projectUuid: string) => useQuery({
    queryKey: [QUERY_KEYS.PROJECT_ASSETS, projectUuid],
    queryFn: () => getProjectAssets(projectUuid),
    staleTime: 5000,
    refetchOnMount: true,
});

export default useGetProjectAssets;
